import type React from "react"

export const Circle: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Circle</title>
    <circle
      cx="12.5"
      cy="12"
      r="11"
      fill="white"
      stroke="#938F94"
      stroke-width="2"
    />
  </svg>
)
